import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Ariakit from '@ariakit/react';
import { forwardRef, useState } from 'react';
import { SelectMark } from '../../components/Icons';
import { useSupportsHover } from '../../lib/hooks';
import * as Styles from './styles';
const DefaultTooltip = forwardRef(function TooltipContent({ children, ...rest }, ref) {
    const tooltipContext = Ariakit.useTooltipContext();
    const tooltipState = Ariakit.useStoreState(tooltipContext);
    const placement = tooltipState?.placement ?? 'top';
    return (_jsxs(Styles.Tooltip, { ref: ref, placement: placement, ...rest, children: [_jsx(Styles.TooltipArrow, {}), children] }));
});
const DefaultDialog = forwardRef(function DefaultDialog({ children, ...rest }, ref) {
    return (_jsx(Styles.Dialog, { ref: ref, ...rest, children: _jsxs(Styles.DialogInner, { children: [_jsx(Styles.DialogDismiss, { "aria-label": 'Close dialog', children: _jsx(SelectMark, { height: '16px', width: '16px' }) }), _jsx("div", { children: children })] }) }));
});
export function Tooltip({ content, children, timeout = 0, placement = 'top', className, renderTooltip = _jsx(DefaultTooltip, {}), renderDialog = _jsx(DefaultDialog, {}), ...rest }) {
    const supportsHover = useSupportsHover();
    const [dialogOpen, setDialogOpen] = useState(false);
    if (supportsHover) {
        return (_jsxs(Ariakit.TooltipProvider, { timeout: timeout, placement: placement, ...rest, children: [_jsx(Ariakit.TooltipAnchor, { render: children }), _jsx(Ariakit.Tooltip, { gutter: 0, className: className, render: renderTooltip, unmountOnHide: true, children: content })] }));
    }
    return (_jsxs(Ariakit.DialogProvider, { children: [_jsx(Ariakit.Button, { onClick: () => setDialogOpen(true), render: children }), _jsx(Ariakit.Dialog, { className: className, backdrop: _jsx(Styles.DialogOverlay, {}), open: dialogOpen, onClose: () => setDialogOpen(false), render: renderDialog, unmountOnHide: true, children: content })] }));
}
Tooltip.DefaultDialog = DefaultDialog;
Tooltip.DefaultTooltip = DefaultTooltip;
//# sourceMappingURL=index.js.map